<template>
  <div class="modal-out">
    <div class="modal" style="width: 900px;">
      <div class="modal-header">
        <div style="padding: 6px;">MESH设备</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <template>
          <el-table :data="tableData" v-loading="loading" border height="400">
            <el-table-column prop="deviceName" label="设备名称" width="200"></el-table-column>
            <el-table-column prop="zone" label="设备位置" width="100"></el-table-column>

            <el-table-column label="人体检测报警类型" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.model=='SY28012' && scope.row.alertTypePerson == 1">有人立即报警</div>
                <div v-if="scope.row.model=='SY28012' && scope.row.alertTypePerson == 2">2天未见人报警</div>
              </template>
            </el-table-column>
            <el-table-column label="门磁报警类型" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.model=='SY28013' && scope.row.alertTypeDoor == 1">开门立即报警</div>
                <div v-if="scope.row.model=='SY28013' && scope.row.alertTypeDoor == 2">2天未开门报警</div>
              </template>
            </el-table-column>

            <el-table-column prop="model" label="Model" width="100"></el-table-column>
            <el-table-column prop="createTime" label="时间" :formatter="timefilter" width="180"></el-table-column>


            <el-table-column fixed="right" label="操作" width="300" prop="type">
              <template slot-scope="scope">

                <el-switch v-if="scope.row.model == 'SY28012' "
                           @change="alertTypePersonChange(scope.row)"
                           v-model="scope.row.type"
                           active-color="#13ce66"
                           inactive-color="#DCDFE6"
                           active-text="有人立即报警"
                           inactive-text="2天未见人报警">
                </el-switch>
                <el-switch v-if="scope.row.model == 'SY28013' "
                           @change="alertTypeDoorChange(scope.row)"
                           v-model="scope.row.typeDoor"
                           active-color="#13ce66"
                           inactive-color="#DCDFE6"
                           active-text="开门立即报警"
                           inactive-text="2天未开门报警">
                </el-switch>

              </template>
            </el-table-column>

          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
 import {hex_md5} from "@/common/Base64MD5";
 import {getStaffCode} from "@/utils/auth";


export default {
  name: "PageForDevice",
  data() {
    return {
      userCode: '',
      tableData:[],
      loading: true,

    }
  },
  components: {
  },

  methods: {
    init(userCode) {
      this.tableData =null;
      this.loading= true;
      this.userCode = userCode;
      this.getList();
    },
    closeSelf() {
      this.$emit("closeMeshDevicePage");
    },
    getList(){

      this.$axios({
          method: 'post',
          //url: this.$deviceUrl+"YiJu/GetMeshDeviceList",
          url: this.$deviceUrl+"DeviceYjgateway/ListMeshDevice",
          data: {
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              staffCode: getStaffCode(),
              userCode:this.userCode
          }
      }).then( (response)=> {
        this.loading = false;

          if(response.data.error == 0){
            this.tableData = response.data.data;

            for(let i=0;i<this.tableData.length;i++){
              if(this.tableData[i].alertTypePerson == 1) {
                this.tableData[i]["type"] = true;
              }else{
                this.tableData[i]["type"] = false;
              }
              if(this.tableData[i].alertTypeDoor == 1) {
                this.tableData[i]["typeDoor"] = true;
              }else{
                this.tableData[i]["typeDoor"] = false;
              }
            }

          }else if(response.data.error == 1){
            this.$message.error(response.data.message)
          }
      }).catch(function (error) {
          console.log(error);
      });
  },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },


    alertTypePersonChange(row){
      //console.log(row);

      let type =0;
      if(row.type){
        type = 1;
      }else{
        type =2;
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceYjgateway/UpdateItemAlertType",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          alertType:type,
          deviceYjgatewayItemCode:row.deviceYjgatewayItemCode,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.getList();
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });


    },
    alertTypeDoorChange(row){
      let type =0;
      if(row.typeDoor){
        type = 1;
      }else{
        type =2;
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceYjgateway/UpdateItemAlertTypeDoor",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          alertTypeDoor:type,
          deviceYjgatewayItemCode:row.deviceYjgatewayItemCode,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.getList();
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    }

  },

}


</script>

<style lang="scss" scoped>

</style>
